
import _forEach from 'lodash/forEach'

const form = new Vue({
    el: '#girona',
    data() {
        return {

        }
    },
    methods: {

    }
});

